import { BrowserRouter } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import ScrollAnimation from "react-animate-on-scroll";
import { Container } from "./styles";
import { useLanguage } from "../../i18n/LanguageContext";
import { renderInlineCode } from "../../i18n/renderInlineCode";

const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=io.OkdeliveryApp.app";

function Paragraphs({ items }: { items: string[] }) {
  return (
    <>
      {items.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
    </>
  );
}

export function CaseStudy() {
  const { t } = useLanguage();
  const copy = t.caseStudy;

  return (
    <Container id="case-ok-delivery">
      <div className="case-layout">
        {/* The animation wrapper is the sticky grid item */}
        <ScrollAnimation animateIn="fadeInUp" className="case-aside">
          <header>
            <p className="eyebrow">{copy.eyebrow}</p>
            <h2>{copy.title}</h2>
            <dl className="case-facts">
              {copy.facts.map((fact) => (
                <div className="case-fact" key={fact.term}>
                  <dt>{fact.term}</dt>
                  <dd>{fact.value}</dd>
                </div>
              ))}
            </dl>
          </header>
        </ScrollAnimation>

        {/* Each block animates on its own: one tall hidden block would read as empty space */}
        <div className="case-article">
          <ScrollAnimation animateIn="fadeInUp">
            <section className="case-block">
              <h3>{copy.problem.heading}</h3>
              <Paragraphs items={copy.problem.paragraphs} />
            </section>
          </ScrollAnimation>

          <ScrollAnimation animateIn="fadeInUp">
            <section className="case-block">
              <h3>{copy.decisions.heading}</h3>
              {copy.decisions.items.map((decision) => (
                <article className="decision" key={decision.claim}>
                  <h4>{decision.claim}</h4>
                  <p>{renderInlineCode(decision.body)}</p>
                </article>
              ))}
            </section>
          </ScrollAnimation>

          <ScrollAnimation animateIn="fadeInUp">
            <section className="case-block">
              <h3>{copy.result.heading}</h3>
              <Paragraphs items={copy.result.paragraphs} />
            </section>
          </ScrollAnimation>

          <div className="case-actions">
            <a
              className="pill-link"
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noreferrer"
              aria-label={copy.googlePlayAria}
            >
              {t.portfolio.linkLabels.googlePlay} <span aria-hidden="true">↗</span>
            </a>
            <BrowserRouter>
              <HashLink smooth to="#portfolio" className="back-link">
                <span aria-hidden="true">←</span> {copy.back}
              </HashLink>
            </BrowserRouter>
          </div>
        </div>
      </div>
    </Container>
  );
}
